export default __webpack_public_path__ + "static/media/278.90d44458.png";